import Vue from 'vue'

Vue.component('large-scheduler', require('../components/Schedulers/LargeScheduler.vue'))

Vue.component('edit-modal', require('../components/Modals/EditModal.vue'))
Vue.component('details-modal', require('../components/Modals/DetailsModal.vue'))
Vue.component('status-modal', require('../components/Modals/StatusModal.vue'))
Vue.component('client-modal', require('../components/Modals/ClientModal.vue'))
Vue.component('staff-modal', require('../components/Modals/StaffModal.vue'))
Vue.component('inquiry-modal', require('../components/Modals/InquiryModal.vue'))

Vue.component('user-avatar', require('../components/UserAvatar.vue'))
Vue.component('user-events', require('../components/Event.vue'))
Vue.component('user-notifications', require('../components/Notification.vue'))
Vue.component('coming-visit', require('../components/ComingVisit.vue'))

Vue.component('select2', require('../components/Select2.vue'))



// WEBPACK FOOTER //
// ./src/common/components.js